import { Typography } from "@mui/material";
import { Page } from "../components/Page";
import { FortuneCatalog } from "./FortuneCatalog";

export function FortuneList() {
  return (
    <Page
      title="Fortune Games"
      description="Play with Fortune Dollars. Try your luck at Cyber Slots or take a seat at Blackjack."
    >
      <Typography component="h2" variant="h4" sx={{ mb: 1 }}>
        Fortune Games
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3, maxWidth: "60ch" }}>
        Play with Fortune Dollars. Try your luck at Cyber Slots or take a seat
        at Blackjack.
      </Typography>
      <FortuneCatalog />
    </Page>
  );
}
